import { GET_REPORTING } from "../../actionTypes";

const initialState = {
  reporting: [],
};

export const reportingReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_REPORTING:
      return {
        ...state,
        reporting: payload.data,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/reportingmanagement/reporting.reducers.js